import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { RadioButtonCell } from '../../../grid/customCells/RadioButtonCell';
import { ViewGrid } from '../ViewGrid';
import { CpsGridCell } from '../../../grid/customCells/CpsGridCell';
import { EDITING_VIEW_FIELD } from '@cs-cms/types';
import { ViewGridTypeEnum } from '../ViewGridType';
import { useViewsContext, useGlobalizationContext, useGetView } from '@cs-cms/state-management';

export const ReadOnlyView: React.FC = () => {
  const { selectedView } = useViewsContext();
  const { selectedLocale } = useGlobalizationContext();
  const { data: defaultView, isLoading: defaultViewLoading } = useGetView(selectedView, selectedLocale);

  const data =
    defaultView?.fields.map(field => ({
      id: field.id,
      name: field.displayName || field.name,
      width: field.width,
      facetable: field.facetable,
      isDocumentLink: field.isDocumentLink
    })) || [];

  const handleCellRender = (cellProps: GridCellProps) => {
    if (!cellProps.field) {
      return <td />;
    }
    if (cellProps.field === EDITING_VIEW_FIELD.LINK) {
      return (
        <RadioButtonCell
          dataItem={cellProps.dataItem}
          field={cellProps.field}
          dataIndex={cellProps.dataIndex}
          id={cellProps.id}
          columnPosition={cellProps.columnPosition}
          onChange={cellProps.onChange}
          className={cellProps.className}
          colSpan={cellProps.colSpan}
          ariaColumnIndex={cellProps.ariaColumnIndex}
          isSelected={cellProps.isSelected}
          style={cellProps.style}
          rowType={cellProps.rowType}
          level={cellProps.level}
          expanded={cellProps.expanded}
          disabled={true}
        />
      );
    }

    return (
      <CpsGridCell
        dataItem={cellProps.dataItem}
        field={cellProps.field}
        dataIndex={cellProps.dataIndex}
        id={cellProps.id}
        columnPosition={cellProps.columnPosition}
        onChange={cellProps.onChange}
        className={cellProps.className}
        colSpan={cellProps.colSpan}
        ariaColumnIndex={cellProps.ariaColumnIndex}
        isSelected={cellProps.isSelected}
        style={cellProps.style}
        rowType={cellProps.rowType}
        level={cellProps.level}
        expanded={cellProps.expanded}
        title={cellProps.dataItem[cellProps.field] || ''}
      >
        {cellProps.dataItem[cellProps.field] || ''}
      </CpsGridCell>
    );
  };

  return (
    <ViewGrid
      type={ViewGridTypeEnum.READ_ONLY_VIEW}
      data={data}
      cellRender={handleCellRender}
      isLoading={defaultViewLoading}
    />
  );
};
